import { configureStore, ThunkAction, Action} from '@reduxjs/toolkit';
import authReducer from '../redux/slices/authSlice';
import blenderReducer from '../redux/slices/consumeBlenderHubSlice';
import blenderApiReducer from '../redux/apis/blenderApiSlice';
import consolePageReducer from '../redux/slices/consolePageSlice';

export const store = configureStore({
    reducer: {
        authState: authReducer,
        blenderState: blenderReducer,
        blenderApiState: blenderApiReducer,
        consolePageState: consolePageReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;